<ion-app>

  <ng-container *ngIf="iabBannerVisible; else appContent">
    <ion-content class="white-background ion-text-center">
      <div class="iab-container">

        <h2 class="iab-main-title">Open in Your Browser</h2>
        <p class="iab-main-subtitle">
          For the best experience, please continue in Chrome or Safari.
        </p>

        <!-- Gmail-specific card -->
        <div class="iab-gmail-card" *ngIf="iabPrimarySteps.length">
          <div class="iab-card-header">
            <span class="iab-gmail-icon">📧</span>
            <span class="iab-card-title">If you opened this from Gmail</span>
          </div>
          <p class="iab-card-subtitle">Follow these steps:</p>

          <div class="iab-steps">
            <div class="iab-step" *ngFor="let step of iabPrimarySteps; let i = index">
              <span class="iab-step-number">{{ i + 1 }}</span>
              <span class="iab-step-text">{{ step }}</span>
            </div>
          </div>
        </div>

        <div class="iab-divider" *ngIf="iabShowOrDivider">
          <span>OR</span>
        </div>

        <!-- Generic card -->
        <div class="iab-generic-card">
          <div class="iab-card-header" *ngIf="iabShowOrDivider">
            <span class="iab-generic-icon">🌐</span>
            <span class="iab-card-title">Using another email app or browser?</span>
          </div>
          <p class="iab-card-subtitle" *ngIf="iabShowOrDivider">Follow these steps:</p>

          <div class="iab-steps">
            <div class="iab-step" *ngFor="let step of iabGenericSteps; let i = index">
              <span class="iab-step-number">{{ i + 1 }}</span>
              <span class="iab-step-text">{{ step }}</span>
            </div>
          </div>
        </div>

        <div class="iab-link-box">
          <span class="iab-link-text" *ngIf="iabCurrentUrl; else noUrlText">{{ iabCurrentUrl }}</span>
          <ng-template #noUrlText>
            <span class="iab-link-text iab-link-missing">Please copy the link from your email</span>
          </ng-template>
        </div>

        <ion-button expand="block" class="iab-copy-btn" [disabled]="!iabCurrentUrl" (click)="iabCopyLink()">
          <ion-icon name="copy-outline" slot="start"></ion-icon>
          {{ iabCopied ? 'COPIED!' : 'COPY LINK' }}
        </ion-button>

      </div>
    </ion-content>
  </ng-container>

  <ng-template #appContent>
    <ion-split-pane contentId="main-content">
      <ion-router-outlet *ngIf="isTaskDetailsLoaded" id="main-content"></ion-router-outlet>
    </ion-split-pane>
    <ion-content *ngIf="!isTaskDetailsLoaded" class="white-background ion-text-center">
      <div fxLayout="column" fxLayoutAlign="space-around center" class="loading-screen-content">
        <h2 class="welcometext">Welcome to your Self-Inspection</h2>
        <ion-spinner name="lines" class="loader-spinner"></ion-spinner>
        <p style="font-size: 18px; color: #000000; font-weight: 500;">We are loading your details</p>
        <p style="font-size: 14px; color: #222222; font-weight: 500;">Please do not refresh or close this screen</p>
      </div>
      <div fxLayout="column" fxLayoutAlign="space-around center" class="footer-content">
        <div class="footer color-netral-500">
          Powered by Digital Eyes™
        </div>
      </div>
    </ion-content>
  </ng-template>

</ion-app>